// import store from "../../frontend/portal-vue/src/core/store"
import { post } from "./util"
import { AdminInstancesResult } from "./types/admin"
import { ProductType } from "./types/productType"
import { ProductInstanceResult } from "./types/productInstances"

export const fetchProductInstances = async (baseUrl: string, productType: ProductType, filters: Record<string, any> = {}): Promise<ProductInstanceResult[] | undefined> => {
    // const { baseUrl } = store.getters
    const url = `${baseUrl}admin/products/${productType}/instances`

    const request = { ...filters, productType }
    const result = await post<any, AdminInstancesResult>(url, request)
    const instances = result.data

    return instances
}
